import React from 'react';
import { connect } from 'react-redux'
import Empresa from './Empresa.jsx';

//Importación de actions.
import {
    changeInput,
    resetState,
    getScreenData,
    showAlert,
    filtroRubro,
    selectRubro,
    removeRubro,
    getGeographicCode,
    validateAddEnterprise,
    getScreenDataRoutting,
    routeToCancel,
    routeToNuevaEmpresa,
    changeDate,
    changeRadio,
    changeCheck,
    changecheckEsConfidencial,
    resetStateEmpresa,
    changeDataError
} from '../actions/Actions.js';


const mapStateToProps = (state) => {
    return {
        data: state.empresa.data,
        tarjetas: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        resetState: () => {
            dispatch(resetState());
        },

        changeDataError: () => {
            dispatch(changeDataError());
        },

        changeInput: (action, value) => {
            dispatch(changeInput(action, value));
        },

        changeRadio: (action, value) => {
            dispatch(changeRadio(action, value));
        },

        changeDate: (action, value) => {
            dispatch(changeDate(action, value));
        },

        getScreenData: (id, currentScope) => {
            dispatch(getScreenData(id, currentScope));
        },

        showAlert: () => {
            dispatch(showAlert());
        },

        filtroRubro: (typeInput, isCheck) => {
            dispatch(filtroRubro(typeInput, isCheck));
        },

        selectRubro: (typeFilter, term) => {
            dispatch(selectRubro(typeFilter, term));
        },

        removeRubro: (id, typeInput) => {
            dispatch(removeRubro(id, typeInput));
        },

        getGeographicCode: (id) => {
            dispatch(getGeographicCode(id));
        },

        showMoreBranches: () => {
            dispatch(showMoreBranches());
        },
        
        validateAddEnterprise: (data, form) => {
            dispatch(validateAddEnterprise(data, form));
        },

        getScreenDataRoutting: (state) => {
            dispatch(getScreenDataRoutting(state));
        },

        routeToCancel: () => {
            dispatch(routeToCancel());
        },

        routeToNuevaEmpresa: (tarjetas_empresas) => {
            dispatch(routeToNuevaEmpresa(tarjetas_empresas));
        },

        changeCheck: (nombreCheck, estadoCheck) => {
            dispatch(changeCheck(nombreCheck, estadoCheck));
        },

        changecheckEsConfidencial: (estadoCheck) => {
            dispatch(changecheckEsConfidencial(estadoCheck));
        },
        resetStateEmpresa: () => {
            dispatch(resetStateEmpresa());
        }
    }
}

//Connect entre el componente y las props y actions.
const EmpresaContainer = connect(mapStateToProps, mapDispatchToProps)(Empresa);

export default EmpresaContainer;